import React from "react";
import LocationItem from "./LocationItem";
import { useTranslation } from "react-i18next";

interface LocationSearchProps {
    seo: boolean;
}

const LocationSearch: React.FC<LocationSearchProps> = ({ seo }) => {
    const { t } = useTranslation();

    const locations = [
        {
            name: t('homePage.locationsSection.location1Name'),
            href: "/immobili/siena/siena?zona=1",
            backgroundImg: "/assets/images/locations/siena1.jpg"
        },
        {
            name: t('homePage.locationsSection.location2Name'),
            href: "/immobili/siena/siena?zona=2&zona=3&zona=4",
            backgroundImg: "/assets/images/locations/siena-fuori.jpg"
        },
        {
            name: t('homePage.locationsSection.location3Name'),
            href: "/immobili/siena?in_campagna=1",
            backgroundImg: "/assets/images/locations/collina.jpg"
        },
        {
            name: t('homePage.locationsSection.location4Name'),
            href: "/immobili?zona=6",
            backgroundImg: "/assets/images/locations/mare.jpg"
        }
    ]

    return (
        <section id="searchForLocation" className="space-pb">
            <div className="container-fluid">
                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="section-title text-center">
                            {seo ? (
                                <h2>{t('homePage.locationsSection.title1')}</h2>
                            ) : (
                                <h3 className="asH2SubTitle">{t('homePage.locationsSection.title2')}</h3>
                            )}
                            <p>{t('homePage.locationsSection.paragraph')}</p>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center justify-content-lg-around p-3">
                    {locations.map((location, index) => (
                        <LocationItem key={index} location={location} />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default LocationSearch;